import { useEffect, useState } from 'react';
import { Link, createSearchParams, useSearchParams } from 'react-router-dom';

export const NotFoundPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [paramString, setParamString] = useState("")
  const pathname = window.location.pathname;

  useEffect(()=>{
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search); 
    const paramString = params.toString();
    const resultURL = window.location.pathname ?? "/dashboard"
    setParamString(paramString)
  }, [searchParams])

  return (
    <div className="flex w-full h-screen justify-center items-center ">
      <div className="flex flex-col w-screen h-screen justify-center items-center gap-2 ">
        {/* <div className="text-base lg:text-xl text-blue/80 font-medium">
          404 ERROR
        </div> */}
        <div className="text-2xl lg:text-6xl text-black font-extrabold">
          OOPS
        </div>
        <div className="text-sm lg:text-xl text-gray-700 font-semibold">
          Either the page does not exist or you are not authorized to access the resource
        </div>
        <button onClick={()=>{
          window.open("/login")
          }} className="underline underline-offset-2 text-blue font-medium cursor-pointer text-green-600 hover:text-black">
          Go back Home
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
